module.exports = __webpack_public_path__ + "static/media/dwt-10.1e344963.jpg";